import { FEED_TOPMANIFESTAZIONI, feedTopManifestazioniActionType, TopManifestazioni } from './types';

export const feedTopManifestazioni = (payload: TopManifestazioni): feedTopManifestazioniActionType => ({
  type: FEED_TOPMANIFESTAZIONI,
  payload,
});
